module.exports = __webpack_public_path__ + "static/img/dili.ec5998e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/dili.jpg
// module id = YrO6
// module chunks = 0